import { ProjectDetailsPage, ProjectListPage } from 'projects/pages';

import { projectDetailsPath, projectListPath } from './routePaths';

export const projects = {
  path: projectListPath(),
  exact: true,
  isPrivate: true,
  element: <ProjectListPage />,
};

export const project = {
  path: projectDetailsPath(),
  exact: true,
  isPrivate: true,
  element: <ProjectDetailsPage />,
};
